module.exports = __webpack_public_path__ + "img/Hamsun_En_omstridt_mann.001bef87.jpg";